module.exports = __webpack_public_path__ + "e70e72baca24c56061e98ee4c1d2b0ce.svg";